import { c as _c } from "react/compiler-runtime";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { useCallback } from "react";
/**
 * Centralizes how the project manager identity is resolved when creating a project or changing
 * its management, so the "implicit main admin" behavior lives in a single place.
 */
export function useResolveProjectManagerIdentity() {
  const $ = _c(6);
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const currentUser = useAppSelector(currentUserSelector);
  let t0;
  if ($[0] !== canAssignManagers || $[1] !== currentUser?.identity) {
    t0 = selectedProjectManager => {
      if (!canAssignManagers) {
        return currentUser?.identity ?? null;
      }
      if (typeof selectedProjectManager === "string") {
        return selectedProjectManager;
      }
      return selectedProjectManager?.identity ?? null;
    };
    $[0] = canAssignManagers;
    $[1] = currentUser?.identity;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const resolveProjectManagerIdentity = t0;
  let t1;
  if ($[3] !== canAssignManagers || $[4] !== resolveProjectManagerIdentity) {
    t1 = {
      canAssignManagers,
      resolveProjectManagerIdentity
    };
    $[3] = canAssignManagers;
    $[4] = resolveProjectManagerIdentity;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}